import { useHistory } from "react-router-dom";

function BackButton() {
    let history = useHistory();

    return (
        <div>
            <button onClick={history.goBack} className="btn btn-lg btn-light-primary fw-bolder"> Cancelar</button>
        </div>
    )
}

export default BackButton
